import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { get, set } from "idb-keyval";
const TRANSPARENT_IMG =
  "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
function MyImg({ src, storageKey }) {
  const [imageSrc, setImageSrc] = useState(src);

  useEffect(() => {
    if (!storageKey) return setImageSrc(src);

    let canceled = false;
    let objectUrl;

    get(storageKey).then((cached) => {
      if (canceled) return;

      if (cached) {
        objectUrl = URL.createObjectURL(cached);
        setImageSrc(objectUrl);
      } else {
        fetch(src)
          .then((res) => {
            if (!res.ok) throw new Error("Image fetch failed");
            return res.blob();
          })
          .then((blob) => {
            if (canceled) return;

            set(storageKey, blob);
            objectUrl = URL.createObjectURL(blob);
            setImageSrc(objectUrl);
          })
          .catch(() => {
            setImageSrc(TRANSPARENT_IMG); // 👈 fallback شفاف
          });
      }
    });

    return () => {
      canceled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src, storageKey]);

  // return (
  //   <LazyLoadImage
  //     alt="image"
  //     effect="blur"
  //     src={imageSrc}
  //     onError={() => setImageSrc(TRANSPARENT_IMG)}
  //   />
  // );
  return (
    <img
      alt="image"
      src={imageSrc}
      onError={() => setImageSrc(TRANSPARENT_IMG)}
    />
  );
}

export default MyImg;
